
import { v4 as uuid } from 'uuid';
import { SpwkUtilV3 } from '../../dao/SpwkUtilV3';
import { UniInput } from '../../dao/UniInput';
import { UniOption } from '../../dao/UniOption';
import { UniQuestion } from '../../dao/UniQuestion';
import { new_ErrorAlert } from '../../export_spwk/ExportManager';
import { SpwkMetaData, SpwkMetaData_DataType } from '../../export_spwk/SpwkMetaData';

export class UiMeta {

  id: string;

  /** 定義檔: UniQuestion | UniOption | UniInput... */
  data_obj: UniQuestion | UniOption | UniInput | null = null;

  /** 定義檔.資料類型 "" | "UniQuestion" | "UniOption" | "UniInput" */
  data_type: SpwkMetaData_DataType = SpwkMetaData_DataType.Unknown;

  /** 定義檔.serno */
  data_serno: number = 0;

  /** 定義檔.guid */
  data_guid: string = "";

  /** rhf 讀取數值的 path */
  rhf_name = "";

  //---------------------------------------------------------- 

  /** 基本資料、作業經歷、既往病史... */
  chapter: string = "";

  /** 題目類型: 單選、多選、非選、標題... */
  question_kind: string = "";

  /** 所屬的題目: 注意! 這裡的是以UI上重新分配的為主，並非資料庫儲存的 */
  question_guid: string = "";

  /** 所屬的選項: 注意! 這裡的是以UI上重新分配的為主，並非資料庫儲存的 */
  option_guid: string = "";

  /** 選項代碼... */
  question_code: string = "";

  /** 選項代碼... */
  option_code: string = "";

  private is_多選_無: boolean = false;
  Is多選_無() {
    return this.is_多選_無;
  }

  /*
  * 注意!! 與轉檔不同，選項可能重新被排列與分配  
  * (原先，option.question_guid 與 input.option_guid... View 系列的參數 可能不可靠!!!)
  * 所以是否在同一題底下，要看當時的 Parent 是誰才準確  
  * rhf_name 應該不會有影響，因為相同的 code 才能合併  
  * 只有 question.guid 或 option.guid 可能不會跟資料庫中的一樣
  */
  constructor(data_obj: UniQuestion | UniOption | UniInput, owner_question: UniQuestion | null, owner_option: UniOption | null) {

    this.id = uuid();// 產生隨機的 guid 讓 MUI.DataGrid id不重複

    //#region 綁定 data_object
    this.data_obj = data_obj;// 對映的物件

    this.data_type = SpwkMetaData.GetDataType(data_obj);// 物件 Class
    this.data_serno = data_obj.serno;
    this.data_guid = data_obj.guid;
    //#endregion

    if (this.data_type === SpwkMetaData_DataType.Question) {
      let question = data_obj as UniQuestion;
      this.InitByQuestion(question);

    } else if (this.data_type === SpwkMetaData_DataType.Option) {
      if (owner_question == null) {
        throw new_ErrorAlert("46343153 owner_question 不可為 null !!!");
      }

      let option = data_obj as UniOption;
      this.InitByOption(option, owner_question);

    } else if (this.data_type === SpwkMetaData_DataType.Input) {
      if (owner_question == null) {
        throw new_ErrorAlert("464661 owner_question 不可為 null !!!");
      }

      if (owner_option == null) {
        throw new_ErrorAlert("4846161 owner_option 不可為 null !!!");
      }

      let input = data_obj as UniInput;
      this.InitByInput(input, owner_question, owner_option);

    } else {
      throw new_ErrorAlert("494665152e 未知的 data_type:" + this.data_type + " !!!");
    }



  }

  InitByQuestion(question: UniQuestion) {

    if (question.kind === SpwkUtilV3.Q_KIND_單選) {
      this.rhf_name = question.get_Question_RhfName();// 單選的 rhf_name

    } else if (question.kind === SpwkUtilV3.Q_KIND_多選) {
      this.rhf_name = question.get_Question_RhfName();// 單選的 rhf_name
    }


    // this.option_guid = "";// 無須指定 選項GUID

    // 注意! 以下的都是以UI重新分配的為主，並非資料庫 LEFT JOIN 出來的
    this.chapter = question.chapter;
    this.question_kind = question.kind;
    this.question_guid = question.guid;

    this.question_code = question.question_code;
    this.option_code = "";
  }


  InitByOption(option: UniOption, owner_question: UniQuestion) {

    if (option.question_kind === SpwkUtilV3.Q_KIND_多選) {
      const chk_name = option.get_Option_RhfName();
      this.rhf_name = chk_name;
    }

    // 注意! 以下的都是以UI重新分配的為主，並非資料庫 LEFT JOIN 出來的
    this.chapter = owner_question.chapter ?? "";// parent.chapter
    this.question_kind = owner_question.kind ?? "";// parent.kind 用來判斷此選項是單選或多選
    this.question_guid = owner_question.guid;

    this.question_code = owner_question.question_code;
    this.option_code = option.option_code;

    this.option_guid = option.guid;

    this.is_多選_無 = option.Is多選_無();
  }

  InitByInput(input: UniInput, owner_question: UniQuestion, owner_option: UniOption) {

    this.rhf_name = (owner_option.get_Input_RhfName(input.input_code));

    // 注意! 以下的都是以UI重新分配的為主，並非資料庫 LEFT JOIN 出來的
    this.chapter = owner_question.chapter;
    this.question_kind = owner_question.kind;
    this.question_guid = owner_question.guid;

    this.question_code = owner_question.question_code;
    this.option_code = owner_option.option_code;

    this.option_guid = owner_option.guid;
  }


  //--------------------------------------------

  Is單選題目() {
    let tf = this.data_type === SpwkMetaData_DataType.Question && this.question_kind === SpwkUtilV3.Q_KIND_單選;
    return tf;
  }

  Is多選題目() {
    let tf = this.data_type === SpwkMetaData_DataType.Question && this.question_kind === SpwkUtilV3.Q_KIND_多選;
    return tf;
  }


  Is多選選項() {
    let tf = this.data_type === SpwkMetaData_DataType.Option && this.question_kind === SpwkUtilV3.Q_KIND_多選;
    return tf;
  }

}